import Model from '../Model';
export default class Forum extends Model {
  apiEndpoint() {
    return '/';
  }
}
flarum.reg.add('core', 'common/models/Forum', Forum);